import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Icon } from '@blueprintjs/core';
import Modal from './Modal';
import Select from 'react-select';
import { getFromLocalStorage } from '../services/utils';
import { jwtDecode } from "jwt-decode";


import ellipsis from '../resources/images/png/menu.png';
import { cities, getCity } from '../services/cities';
import { getAvailablePages, getPageLabel } from '../services/pageNavigation';

const base = 'header';

@inject('UserStore', 'ProductionStore')
@observer
class Header extends Component {
    state = {
        canShowDropdown: true,
        showChangeOutletModal: false,
        selectedHubForChange: null,
        hubsInCurrentCity: [],
        pages: [],
        openDropdown: null
    };
    componentDidMount = () => {
        const {
            location,
            UserStore: { setPage, position },
        } = this.props;

        const pages = getAvailablePages(position);

        const matchedPage = pages.find((page) =>
            location.pathname.includes(page)
        );
        if (matchedPage) {
            setPage(matchedPage);
        }

        const hubsList = getFromLocalStorage('hubsList') || [];
        const jwtToken = getFromLocalStorage('jwtToken');
        let eligibleHubCodes = [];
        if (jwtToken) {
            try {
                const decodedToken = jwtDecode(jwtToken);
                eligibleHubCodes = decodedToken.hubCodes || [];
            } catch (error) {
                console.error('Invalid JWT token:', error);
            }
        }
        let hubsInCurrentCity = hubsList.filter(hub => hub.city === getCity());

        if (eligibleHubCodes) {
            hubsInCurrentCity = hubsInCurrentCity.filter(hub => eligibleHubCodes.includes(hub.value));
        } else {
            hubsInCurrentCity = [];
        }
        this.setState({hubsInCurrentCity: hubsInCurrentCity, pages: pages})
    };

    handleSetPage = (page) => {
        const {
            history,
            UserStore: { setPage },
        } = this.props;

        // Disable the Dropdown visibility
        this.setState({canShowDropdown: false, openDropdown: null});
        setPage(page);
        history.push(`/${page}`);
        // enable the Dropdown visibility
        setTimeout(function () {
            this.setState({canShowDropdown: true})
        }.bind(this), 500)
    };

    handleToggleDropdown = (dropdownName, event) => {
        const target = event.target && event.target.nodeType === 3
            ? event.target.parentElement
            : event.target;

        if (target && target.closest && target.closest('.dropdown-content')) {
            return;
        }

        this.setState((prevState) => ({
            openDropdown: prevState.openDropdown === dropdownName ? null : dropdownName,
        }));
    };

    showOutletChangeModal = () => {
        const { UserStore } = this.props;
        this.setState({
            showChangeOutletModal: true,
            selectedHubForChange: UserStore.selectedHub,
            openDropdown: null,
        });
    };

    handleHubChange = (hub) => {
        this.setState({ selectedHubForChange: hub });
    };

    confirmOutletChange = () => {
        const { UserStore } = this.props;
        UserStore.setSelectedHub(this.state.selectedHubForChange);
        this.closeModal();
        window.location.reload();
    };

    renderHubSelector = () => {
        return (
            <div className={`${base}__hub-selector-container`}>
                <Select
                    value={this.state.selectedHubForChange}
                    autoFocus
                    required
                    options={this.state.hubsInCurrentCity}
                    style={{ width: '523px', marginBottom: '10px' }}
                    name="hubs"
                    onChange={this.handleHubChange}
                    placeholder="Select Outlet"
                />
            </div>
        );
    };

    closeModal = () => {
        this.setState({showChangeOutletModal: false})
    }

    render() {
        const {
            UserStore: {
                selectedHub,
                currentPage,
                logout,
                handleSetFullscreen,
            },
            match,
            location,
        } = this.props;
        const {
            showChangeOutletModal,
            selectedHubForChange,
            pages,
            openDropdown
        } = this.state;
        const city = cities[getCity()];
        console.log({ currentPage });

        if (location.pathname.includes('inventory/')) {
            return null;
        }

        return (
            <div className={`${base}`}>
                <div className={`${base}__container display--flex`}>
                    <h3 className={`${base}__title`}>
                        {selectedHub && `${selectedHub.pickupAddress.name}`}
                    </h3>

                    <div className={`display--flex flex-align-items-center `}>
                        {(currentPage === 'orders-kitchen' ||
                            currentPage === 'live-dispatch' ||
                            currentPage === 'packing') && (
                            <button
                                className={`${base}__fullscreen_btn`}
                                onClick={() => handleSetFullscreen()}
                            >
                                <Icon
                                    icon="fullscreen"
                                    iconSize={30}
                                    color={'white'}
                                />
                            </button>
                        )}

                        <div
                            className={`${base}__dropdown ${openDropdown === 'pages' ? 'is-open' : ''}`}
                            tabIndex={0}
                            onClick={(event) => this.handleToggleDropdown('pages', event)}
                        >
                            <span className={`${base}__dropdown-label`}>
                                {getPageLabel(currentPage)}
                            </span>
                            <svg fill="#fff" className="iconmoon-icon">
                                <use xlinkHref={`#icon-caret-down`} />
                            </svg>
                            {this.state.canShowDropdown && <div className={`dropdown-content pages`}>
                                {pages
                                    .filter((page) => page !== currentPage)
                                    .map((page, i) => (
                                        <a
                                            key={i}
                                            className="cursor-pointer"
                                            onClick={() =>
                                                this.handleSetPage(page)
                                            }
                                        >
                                            {getPageLabel(page)}
                                        </a>
                                    ))}
                            </div>}
                        </div>
                        <div
                            className={`${base}__dropdown signout text--white ${openDropdown === 'signout' ? 'is-open' : ''}`}
                            tabIndex={0}
                            onClick={(event) => this.handleToggleDropdown('signout', event)}
                        >
                            <img
                                className={`${base}__ellipsis`}
                                src={ellipsis}
                                alt="ellipsis icon"
                            ></img>
                            <div className={`dropdown-content`}>
                                <a
                                    className="cursor-pointer"
                                    onClick={() => this.showOutletChangeModal()}
                                >
                                    Change Outlet
                                </a>
                                <a
                                    className="cursor-pointer"
                                    onClick={() => logout()}
                                >
                                    Sign out
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {showChangeOutletModal && (
                    <Modal onBackdropClicked={this.closeModal} borderRadius={'10px'} overflow={'hidden'}>
                        <h1>Change Outlet</h1>
                        {this.renderHubSelector()}
                        <div className={`${base}__submit_cancel`}>
                                    <button
                                        className={`${base}__button cancel`}
                                        onClick={this.closeModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className={`${base}__button confirm`}
                                        onClick={this.confirmOutletChange} disabled={!selectedHubForChange}
                                    >
                                        Confirm
                                    </button>
                                </div>
                    </Modal>
                )}
            </div>
        );
    }
}

export default withRouter(Header);
